module.exports = __webpack_public_path__ + "images/花筑院子全景_02视频.jpg?v=781caf61";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_02视频.jpg
 ** module id = 70
 ** module chunks = 1 2
 **/